import { PendingAgentOrder } from './agent-plan-buy-constants';

// A person approves an agent draft (POST /agent_orders/approve), and then the agent can send it.
// The server refuses to send an agent order that a person has not approved.
export const needsApproval = (order: PendingAgentOrder): boolean => !order.approved_at;

export const agentOrderStatusLabel = (order: PendingAgentOrder): string =>
  needsApproval(order) ? 'Draft - needs approval' : 'Approved - ready to send';

// Drafts that need approval come first, then the newest first.
export const sortAgentOrders = (orders: PendingAgentOrder[]): PendingAgentOrder[] =>
  [...orders].sort((a, b) => {
    const byApproval = Number(needsApproval(b)) - Number(needsApproval(a));
    return byApproval || b.id - a.id;
  });

export const countAgentOrdersNeedingApproval = (orders: PendingAgentOrder[]): number =>
  orders.filter(needsApproval).length;

// Drafts first (newest first), then approved orders (newest first), for the orders panel's two groups.
export const splitAgentOrders = (
  orders: PendingAgentOrder[]
): { drafts: PendingAgentOrder[]; approved: PendingAgentOrder[] } => {
  const sorted = sortAgentOrders(orders);
  return {
    drafts: sorted.filter(needsApproval),
    approved: sorted.filter(order => !needsApproval(order))
  };
};

// IDs of drafts in `orders` that were not in `previousIds`: the drafts the agent just created.
export const findNewDrafts = (previousIds: Set<number>, orders: PendingAgentOrder[]): number[] =>
  orders.filter(order => needsApproval(order) && !previousIds.has(order.id)).map(order => order.id);
